import { Link } from 'react-router-dom';
import { companyInfo, openingHours } from '../data/siteData';

export default function Footer() {
  return (
    <footer className="bg-[#0B132B] text-white pt-20 pb-12 border-t border-[#B5A897]/20">
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16 border-b border-white/10">
          
          {/* Column 1: Company Profile */}
          <div className="space-y-6">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/807b5052-bea6-494e-8947-b0c29529a13c/logo-trans.png"
              alt="Brønshøj Ure & Guld Logo"
              className="h-18 sm:h-20 w-auto object-contain brightness-0 invert"
            />
            <p className="text-xs text-stone-300 leading-relaxed tracking-wider font-sans">
              Din lokale guldsmed og urmager i Brønshøj med over 35 års erfaring. Vi tilbyder faglig rådgivning, guldkøb, reparationsværksted og unika smykkedesign.
            </p>
            <div className="pt-2 flex items-center gap-3">
              <a
                href={companyInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-none bg-white/5 border border-white/20 flex items-center justify-center text-[#B5A897] hover:bg-white hover:text-[#0B132B] transition-all"
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram text-sm" aria-hidden="true"></i>
              </a>
              <a
                href={companyInfo.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-none bg-white/5 border border-white/20 flex items-center justify-center text-[#B5A897] hover:bg-white hover:text-[#0B132B] transition-all"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f text-sm" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Commercial Focus & Links */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg tracking-[0.2em] uppercase text-[#B5A897] font-normal border-b border-white/10 pb-3">
              Servicetilbud
            </h3>
            <ul className="space-y-3 text-xs tracking-[0.15em] uppercase text-stone-300">
              <li>
                <Link
                  to="/vi-koeber-guld-og-soelv"
                  className="hover:text-[#B5A897] transition-colors flex items-center gap-2 font-medium text-white"
                >
                  <i className="fa-solid fa-coins text-[#B5A897] text-[10px]" aria-hidden="true"></i>
                  <span>Vi køber guld & sølv</span>
                </Link>
              </li>
              <li>
                <Link to="/guldsmedevaerksted" className="hover:text-[#B5A897] transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-gem text-[#B5A897]/70 text-[10px]" aria-hidden="true"></i>
                  <span>Guldsmedeværksted</span>
                </Link>
              </li>
              <li>
                <Link to="/smykker-eget-design" className="hover:text-[#B5A897] transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-wand-magic-sparkles text-[#B5A897]/70 text-[10px]" aria-hidden="true"></i>
                  <span>Smykker efter eget design</span>
                </Link>
              </li>
              <li>
                <Link to="/urereparation" className="hover:text-[#B5A897] transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-clock text-[#B5A897]/70 text-[10px]" aria-hidden="true"></i>
                  <span>Urereparation</span>
                </Link>
              </li>
              <li>
                <Link to="/brands" className="hover:text-[#B5A897] transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-award text-[#B5A897]/70 text-[10px]" aria-hidden="true"></i>
                  <span>Brands</span>
                </Link>
              </li>
              <li>
                <Link to="/inspration" className="hover:text-[#B5A897] transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-heart text-[#B5A897]/70 text-[10px]" aria-hidden="true"></i>
                  <span>Inspiration</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Opening Hours */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg tracking-[0.2em] uppercase text-[#B5A897] font-normal border-b border-white/10 pb-3">
              Åbningstider
            </h3>
            <ul className="space-y-1 text-xs tracking-wider">
              {openingHours.map((item) => (
                <li key={item.day} className="flex justify-between items-center py-2 border-b border-white/10">
                  <span className="text-stone-400 uppercase text-[10px] tracking-[0.2em]">{item.day}:</span>
                  <span className={`font-medium ${item.hours === 'LUKKET' ? 'text-stone-500' : 'text-white'}`}>
                    {item.hours}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact details */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg tracking-[0.2em] uppercase text-[#B5A897] font-normal border-b border-white/10 pb-3">
              Kontakt Os
            </h3>
            <div className="space-y-4 text-xs text-stone-300 tracking-wider">
              <p className="font-semibold text-white uppercase tracking-[0.15em]">Brønshøj Ure og Guld</p>
              <p className="text-stone-400 leading-relaxed">
                {companyInfo.address}<br />
                {companyInfo.zipCity}
              </p>
              <div className="space-y-2 pt-1 text-xs">
                <p>
                  <span className="text-stone-400 uppercase text-[10px] tracking-widest">Telefon: </span>
                  <a
                    href={`tel:${companyInfo.phoneRaw}`}
                    className="text-[#B5A897] hover:underline font-medium whitespace-nowrap"
                  >
                    {companyInfo.phone}
                  </a>
                </p>
                <p>
                  <span className="text-stone-400 uppercase text-[10px] tracking-widest">Email: </span>
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="text-[#B5A897] hover:underline font-medium whitespace-nowrap"
                  >
                    {companyInfo.email}
                  </a>
                </p>
                <p>
                  <span className="text-stone-400 uppercase text-[10px] tracking-widest">CVR: </span>
                  <span className="text-stone-300 font-mono">{companyInfo.cvr}</span>
                </p>
              </div>

              <div className="pt-3">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 text-white text-xs font-medium uppercase tracking-[0.2em] rounded-none hover:bg-white hover:text-[#0B132B] transition-all"
                >
                  <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                  <span>Send os en besked</span>
                </Link>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom copyright line */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center text-[11px] uppercase tracking-[0.2em] text-stone-500 gap-4">
          <p>© {new Date().getFullYear()} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
          <p>
            Lokal guldsmed & urmager i Brønshøj
          </p>
        </div>
      </div>
    </footer>
  );
}
